/**
 * Trusted Partners Modal
 * Handles opening and closing of partner modal windows
 */

(function() {
	'use strict';

	const modal = document.getElementById('partner-modal');
	if (!modal) {
		return;
	}

	const modalOverlay = modal.querySelector('.trusted-section__modal-overlay');
	const modalClose = modal.querySelector('.trusted-section__modal-close');
	const modalLogo = document.getElementById('partner-modal-logo');
	const modalTitle = document.getElementById('partner-modal-title');
	const modalLink = document.getElementById('partner-modal-link');
	const modalLinkText = document.getElementById('partner-modal-link-text');
	const modalTags = document.getElementById('partner-modal-tags');
	const modalDescription = document.getElementById('partner-modal-description');

	const partnerCards = document.querySelectorAll('[data-partner-modal]');
	const modalContent = modal.querySelector('.trusted-section__modal-content');

	let lastOpenedCard = null;

	/**
	 * Lock scroll without changing position: overflow:hidden + Lenis.stop().
	 * Avoids position:fixed which causes scroll jump when unlocking.
	 */
	function lockScroll() {
		document.documentElement.style.overflow = 'hidden';
		document.body.style.overflow = 'hidden';

		if (typeof window.evonaLenis !== 'undefined' && window.evonaLenis && typeof window.evonaLenis.stop === 'function') {
			window.evonaLenis.stop();
		}

		document.addEventListener('touchmove', preventScrollOutsideModal, { passive: false });
	}

	/**
	 * Unlock scroll — position never changed, just remove lock.
	 */
	function unlockScroll() {
		document.removeEventListener('touchmove', preventScrollOutsideModal);

		document.documentElement.style.overflow = '';
		document.body.style.overflow = '';

		if (typeof window.evonaLenis !== 'undefined' && window.evonaLenis && typeof window.evonaLenis.start === 'function') {
			window.evonaLenis.start();
		}
	}

	/**
	 * Prevent touch scroll on document, allow inside modal content
	 */
	function preventScrollOutsideModal(e) {
		if (modalContent && modalContent.contains(e.target)) {
			return;
		}
		e.preventDefault();
	}

	/**
	 * Extract image URL from card's img element
	 */
	function extractImageUrlFromCard(card) {
		const img = card.querySelector('img');
		if (img && img.src) {
			return img.src;
		}
		return null;
	}

	/**
	 * Open modal with partner data
	 * @param {Object|string} partnerData - Partner data object or JSON string
	 * @param {Element|null} [triggerCard] - Card that opened the modal (for focus restore on close)
	 */
	function openModal(partnerData, triggerCard) {
		if (!partnerData) {
			return;
		}
		lastOpenedCard = triggerCard && triggerCard.nodeType === 1 ? triggerCard : null;

		// Parse partner data if it's a string
		if (typeof partnerData === 'string') {
			try {
				partnerData = JSON.parse(partnerData);
			} catch (e) {
				console.error('Error parsing partner data:', e);
				return;
			}
		}

		// Set logo - use featured/partner image (modal_logo_url), not card image
		if (modalLogo) {
			if (partnerData.modal_logo_url) {
				modalLogo.src = partnerData.modal_logo_url;
				modalLogo.alt = partnerData.title || '';
			} else if (partnerData.image_url) {
				modalLogo.src = partnerData.image_url;
				modalLogo.alt = partnerData.title || '';
			} else if (partnerData.image_id) {
				const card = document.querySelector(`[data-partner-modal][data-partner-data*="${partnerData.image_id}"]`);
				if (card) {
					const imageUrl = extractImageUrlFromCard(card);
					if (imageUrl) {
						modalLogo.src = imageUrl;
						modalLogo.alt = partnerData.title || '';
					}
				}
			}
		}

		// Set title
		if (modalTitle && partnerData.title) {
			modalTitle.textContent = partnerData.title;
		}

		// Set link
		if (modalLink && modalLinkText && partnerData.link) {
			modalLink.href = partnerData.link;
			// Extract domain from URL for display
			try {
				const url = new URL(partnerData.link);
				modalLinkText.textContent = url.hostname.replace('www.', '');
			} catch (e) {
				modalLinkText.textContent = partnerData.link;
			}
			modalLink.style.display = 'flex';
		} else if (modalLink) {
			modalLink.style.display = 'none';
		}

		// Set tags
		if (modalTags && partnerData.tags && partnerData.tags.length > 0) {
			modalTags.innerHTML = '';
			partnerData.tags.forEach(function(tag) {
				const tagElement = document.createElement('span');
				tagElement.className = 'trusted-section__modal-tag';
				tagElement.textContent = tag.name || tag;
				modalTags.appendChild(tagElement);
			});
			modalTags.style.display = 'flex';
		} else if (modalTags) {
			modalTags.style.display = 'none';
		}

		// Set description
		if (modalDescription && partnerData.description) {
			modalDescription.innerHTML = partnerData.description;
			modalDescription.style.display = 'block';
		} else if (modalDescription) {
			modalDescription.style.display = 'none';
		}

		// Show modal
		modal.classList.add('is-open');
		lockScroll();

		// Raise stacking context so modal stays above sibling sections (timeline, solution)
		// Modal is outside section (sibling in wrapper) - add class to wrapper
		const trustedWrapper = document.querySelector('.trusted-section-wrapper');
		if (trustedWrapper) {
			trustedWrapper.classList.add('is-modal-open');
		}
	}

	/**
	 * Close modal
	 */
	function closeModal() {
		if (lastOpenedCard && document.body.contains(lastOpenedCard)) {
			try {
				if (!lastOpenedCard.hasAttribute('tabindex')) {
					lastOpenedCard.setAttribute('tabindex', '-1');
				}
				lastOpenedCard.focus({ preventScroll: true });
			} catch (err) {
				// ignore if element cannot receive focus
			}
			lastOpenedCard = null;
		}
		modal.classList.remove('is-open');
		unlockScroll();

		const trustedWrapper = document.querySelector('.trusted-section-wrapper');
		if (trustedWrapper) {
			trustedWrapper.classList.remove('is-modal-open');
		}
	}

	// Event listeners for opening modal
	partnerCards.forEach(function(card) {
		card.addEventListener('click', function(e) {
			e.preventDefault();
			const partnerDataStr = card.getAttribute('data-partner-data');
			if (partnerDataStr) {
				const partnerData = JSON.parse(partnerDataStr);
				// modal_logo_url is set from PHP (featured/partner image); do not override with card image
				openModal(partnerData, card);
			}
		});
	});

	// Close modal handlers
	if (modalClose) {
		modalClose.addEventListener('click', function(e) {
			e.preventDefault();
			closeModal();
		});
	}

	if (modalOverlay) {
		modalOverlay.addEventListener('click', function(e) {
			e.preventDefault();
			closeModal();
		});
	}

	// Close on Escape key
	document.addEventListener('keydown', function(e) {
		if (e.key === 'Escape' && modal.classList.contains('is-open')) {
			closeModal();
		}
	});
})();
